export default __webpack_public_path__ + "../staticImages/sprite-wineinmoderation-2x.png";